<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Commercial gestures</h1>
                    <p>Gestion des gestes commerciaux</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxshop.commercialgesture.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un geste commercial</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" active-advanced-filter="false" active-tabs="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div></div>
                        <div class="center">
                          <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Identifiant', value:'internal_identifier'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div><span>Scopes</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxshop.commercialgesture.view', item.id )">
                        <div></div>
                        <div class="picture no-radius">
                          <figure>
                            <icon name="coins-hand"/>
                          </figure>
                        </div>
                        <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                        <div data-field="name"><strong class="highlight">{{ item.name }}</strong><p>{{ item.description }}</p></div>
                        <div data-field="internal_identifier">{{ item.internal_identifier }}</div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="actions">
                            <ul>
                                <li v-if="$aclInterfaceValidator('weeboxshop.commercialgesture.update', item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxshop.commercialgesture.update', item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import CommercialGestureService from './CommercialGestureService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return CommercialGestureService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/commercial-gesture/Index.vue